<template>
    <b-card no-body>
        <b-modal id="modal-configuration" :title="editing ? 'Ayar Güncelle' : 'Yeni Ayar Ekle'" size="lg" no-close-on-backdrop>
            <configuration-form v-model="editedItem" :errors="errors" :languages="languages" :config-groups="configGroups" />
            <template #modal-footer>
                <v-executer :loading="loading" :action="save" :text="editing ? 'Güncelle' : 'Oluştur'" />
            </template>
        </b-modal>

        <v-table ref="table" :fields="fields" :items-provider="provider" :add-callback="createNew" :buttons="buttons" pagination="client" search>
            <template #filters>
                <div class="row">
                    <div class="col-md-6">
                        <label>Grup Filtrele</label>
                        <v-select-list v-model="selectedGroup" :options="configGroups" label="label" :reduce="(item) => item.value" placeholder="Tüm Gruplar" :disabled="false" :loading="false" />
                    </div>
                    <div class="col-md-6">
                        <label>Dil Filtrele</label>
                        <v-select-list
                            v-model="selectedLanguage"
                            :options="languages"
                            :reduce="(lang) => lang.LanguageCode"
                            label="LanguageName"
                            placeholder="Tüm Diller"
                            :disabled="false"
                            :loading="languagesLoading"
                        />
                    </div>
                </div>
            </template>
        </v-table>
    </b-card>
</template>

<script>
import { BCard, BRow, BCol, BFormGroup, BBadge } from "bootstrap-vue";
import WebsiteApi from "@/api/website";
import ConfigurationForm from "./components/ConfigurationForm.vue";
import VTable from "@/components/VTable.vue";
import VSelectList from "@/components/VSelectList.vue";
import VExecuter from "@/components/VExecuter.vue";

export default {
    name: "ConfigurationManagement",
    components: {
        BCard,
        BRow,
        BCol,
        BFormGroup,
        BBadge,
        ConfigurationForm,
        VTable,
        VSelectList,
        VExecuter,
    },
    data() {
        return {
            loading: false,
            languagesLoading: false,
            editing: false,
            errors: {},
            selectedGroup: null,
            selectedLanguage: null,
            languages: [],
            configGroups: [
                { label: "Metadata", value: "metadata" },
                { label: "Social", value: "social" },
                { label: "Contact", value: "contact" },
                { label: "SEO", value: "seo" },
                { label: "Analytics", value: "analytics" },
                { label: "Theme", value: "theme" },
            ],
            fields: [
                { key: "ConfigGroup", name: "Grup", sortable: true, thClass: "text-nowrap" },
                { key: "ConfigKey", name: "Anahtar", sortable: true, thClass: "text-nowrap" },
                { key: "ConfigValue", name: "Değer", sortable: false },
                {
                    key: "DataType",
                    name: "Tip",
                    sortable: true,
                    tdClass: "text-center",
                    thClass: "text-nowrap",
                    component: true,
                    componentOptions: { name: "website/DataTypeBadge" },
                },
                {
                    key: "LanguageCode",
                    name: "Dil",
                    sortable: true,
                    tdClass: "text-center",
                    thClass: "text-nowrap",
                    component: true,
                    componentOptions: { name: "website/LanguageBadge" },
                },
                {
                    key: "IsActive",
                    name: "Durum",
                    sortable: true,
                    tdClass: "text-center",
                    thClass: "text-nowrap",
                    component: true,
                    componentOptions: { name: "website/StatusBadge" },
                },
            ],
            buttons: [
                { text: "Düzenle", key: "edit", icon: "Edit2Icon", variant: "secondary", action: this.edit },
                { text: "Sil", key: "delete", icon: "TrashIcon", variant: "danger", action: this.deleteItem },
            ],
            editedItem: {
                id: null,
                configKey: "",
                configValue: "",
                configGroup: "",
                languageCode: null,
                description: "",
                dataType: "string",
                defaultValue: "",
                isActive: true,
            },
        };
    },
    watch: {
        selectedGroup() {
            this.$refs.table.refresh();
        },
        selectedLanguage() {
            this.$refs.table.refresh();
        },
    },
    created() {
        this.loadLanguages();
    },
    methods: {
        provider() {
            let apiCall;
            if (this.selectedGroup) {
                apiCall = WebsiteApi.Configuration.GetByGroup(this.selectedGroup, this.selectedLanguage);
            } else {
                apiCall = WebsiteApi.Configuration.GetAll(this.selectedLanguage);
            }

            return apiCall;
        },

        loadLanguages() {
            this.languagesLoading = true;
            WebsiteApi.Language.GetAll()
                .then((response) => {
                    if (response.data.Success && response.data.Data) {
                        this.languages = response.data.Data;
                    }
                })
                .catch((error) => {
                    this.$result(null, error);
                })
                .finally(() => {
                    this.languagesLoading = false;
                });
        },

        clearForm() {
            this.editing = false;
            this.errors = {};
            this.editedItem = {
                id: null,
                configKey: "",
                configValue: "",
                configGroup: "",
                languageCode: null,
                description: "",
                dataType: "string",
                defaultValue: "",
                isActive: true,
            };
        },

        createNew() {
            this.clearForm();
            this.$bvModal.show("modal-configuration");
        },

        edit(item) {
            this.clearForm();
            this.editing = true;
            this.editedItem = {
                id: item.Id,
                configKey: item.ConfigKey,
                configValue: item.ConfigValue,
                configGroup: item.ConfigGroup,
                languageCode: item.LanguageCode,
                description: item.Description,
                dataType: item.DataType,
                defaultValue: item.DefaultValue,
                isActive: item.IsActive,
            };
            this.$bvModal.show("modal-configuration");
        },

        save() {
            this.errors = {};

            if (!this.editedItem.configKey) {
                this.$set(this.errors, "configKey", "Ayar anahtarı zorunludur.");
                return;
            }

            if (!this.editedItem.configGroup) {
                this.$set(this.errors, "configGroup", "Grup seçimi zorunludur.");
                return;
            }

            const payload = {
                ConfigKey: this.editedItem.configKey,
                ConfigValue: this.editedItem.configValue,
                ConfigGroup: this.editedItem.configGroup,
                LanguageCode: this.editedItem.languageCode,
                Description: this.editedItem.description,
                DataType: this.editedItem.dataType,
                DefaultValue: this.editedItem.defaultValue,
                IsActive: this.editedItem.isActive,
            };

            this.loading = true;

            const apiCall = this.editing ? WebsiteApi.Configuration.Update(this.editedItem.id, payload) : WebsiteApi.Configuration.Create(payload);

            apiCall
                .then((response) => {
                    if (response.data.Success) {
                        this.$refs.table.refresh();
                        this.$bvModal.hide("modal-configuration");
                    } else if (response.data && response.data.errors) {
                        this.errors = response.data.errors;
                    }
                    this.$result(response);
                })
                .catch((err) => {
                    if (err.response && err.response.data && err.response.data.errors) {
                        this.errors = err.response.data.errors;
                    }
                    this.$result(null, err);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        deleteItem(item) {
            this.$confirm("Ayarı Sil", `"${item.ConfigKey}" ayarını silmek istediğinize emin misiniz?`).then((result) => {
                if (result) {
                    WebsiteApi.Configuration.Delete(item.Id)
                        .then((response) => {
                            if (response.data.Success) {
                                this.$refs.table.refresh();
                            }
                            this.$result(response);
                        })
                        .catch((err) => {
                            this.$result(null, err);
                        });
                }
            });
        },

        getDataTypeBadge(type) {
            const badges = {
                string: "light-primary",
                number: "light-success",
                boolean: "light-warning",
                json: "light-info",
            };
            return badges[type] || "light-secondary";
        },

        truncate(text, length) {
            if (!text) return "-";
            return text.length > length ? text.substring(0, length) + "..." : text;
        },
    },
};
</script>

<style scoped>
.config-value-cell {
    max-width: 300px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>
